import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { SRModal } from '@sr/ui'
import { BUTTON_VARIANTS, Button } from '@shared/ui'

import { CheckmarkFilled } from '@carbon/icons-react'

import './styles.scss'
import { disabledButton } from './styles'

type ConfirmModalProps = {
  onAction?: () => void
  onClose: () => void
  children: JSX.Element
  onCancelText?: string
  onConfirmText?: string
  selectedValue?: string | null
  title?: string
  location?: string
  textColor?: string
  disabledValidation?: boolean
  icon?: boolean
}

export const SRConfirmModal: FC<ConfirmModalProps> = ({
  onAction,
  onClose,
  children,
  onCancelText = 'common:cancel',
  onConfirmText = 'common:confirm',
  selectedValue = '',
  title = '',
  location,
  disabledValidation = false,
  icon,
}) => {
  const { t } = useTranslation()

  return (
    <SRModal onClose={onClose} title={title}>
      <div className={`${title ? '!items-baseline' : ''} sr-confirm-modal`}>
        {icon && <CheckmarkFilled size={50} />}
        <div>{children}</div>
      </div>
      <div
        className={`${
          location ? `sr-confirm-modal__justify_${location}` : ''
        } sr-confirm-modal__button`}
      >
        <Button variant={BUTTON_VARIANTS.outlined} onClick={onClose}>
          {t(onCancelText)}
        </Button>
        <Button
          onClick={onAction}
          className={`${
            !selectedValue && disabledValidation && disabledButton
          }`}
        >
          {t(onConfirmText)}
        </Button>
      </div>
    </SRModal>
  )
}
